module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header css-margin-top"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.title === '工艺曲线') ? _c('div', {
    staticClass: "state",
    class: {
      'state-off': _vm.deviceInfo.device_status !== '在线'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.title === '工艺曲线') ? _c('div', {
    staticClass: "device-statue"
  }, [_vm._v("\n      " + _vm._s(_vm.deviceInfo.device_status) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ddce87ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tempControl/header.vue
// module id = 931
// module chunks = 1